import React from 'react';
import PropTypes from 'prop-types';
import {
  allowedTableDataShape,
  allowedPaginationProps,
  allowedTranslationLabelProps
} from '../utils/allowedPropTypes';
import DataTableBody from './_DataTableBody';
import DataTableFoot from './_DataTableFoot';
import DataTableHead from './_DataTableHead';

const DataTableContent = ({ tableData, attributesOfTableParts, isDataReady, hideTableHead }) => {
  const tableParts = [
    {
      tablePartName: 'body',
      component: DataTableBody
    },
    {
      tablePartName: 'foot',
      component: DataTableFoot
    }
  ];

  if (!hideTableHead) {
    tableParts.unshift({
      tablePartName: 'head',
      component: DataTableHead
    });
  }

  if (tableData.dataToProcess.length < 1 && !isDataReady) { // TODO: check for isError
    return (
      <tbody>
        <tr>
          <td className='text-center'>Loading...</td>
          {' '}
          {/* TODO: add label */}
        </tr>
      </tbody>
    );
  }

  return (
    <React.Fragment>
      {tableParts.map(({ tablePartName, component: TablePartComponent }) => (
        <TablePartComponent
          {...attributesOfTableParts[tablePartName]}
          isDataReady={isDataReady}
          key={`table-${tablePartName}`}
        />
      ))}
    </React.Fragment>
  );
};

DataTableContent.propTypes = {
  tableData: PropTypes.shape(allowedTableDataShape).isRequired,
  isDataReady: PropTypes.bool.isRequired,
  hideTableHead: PropTypes.bool,

  // TODO: delete this prop check when props are passed via CONTEXT:
  attributesOfTableParts: PropTypes.shape({
    tableItems: PropTypes.array,
    tableColumns: PropTypes.array,
    dataLabel: PropTypes.string, // TODO: Get rid off this premature and overcomplicated optimization
    labels: PropTypes.shape(allowedTranslationLabelProps),
    paginationData: PropTypes.shape(allowedPaginationProps)
  }).isRequired
};

export default DataTableContent;